export default __webpack_public_path__ + "static/media/white_back_arrow.3529f398.svg";